/**
 * AJ-Captcha API 接口
 * 适配项目的 ApiResponse 格式
 */

import api from '../../../api/index.js' // 使用项目的 axios 实例

// 获取验证图片以及token
export function reqGet(data) {
  return api.post('/captcha/get', data).then(response => {
    // 适配标准格式：将 ApiResponse 转换为 AJ-Captcha 期望的格式
    if (response.success && response.data) {
      return {
        repCode: '0000',
        repMsg: 'success',
        repData: response.data
      }
    } else {
      return {
        repCode: '9999',
        repMsg: response.message || '获取验证码失败',
        repData: null
      }
    }
  }).catch(error => {
    return {
      repCode: '9999',
      repMsg: error.response?.data?.message || '获取验证码失败',
      repData: null
    }
  })
}

// 滑动或者点选验证
export function reqCheck(data) {
  return api.post('/captcha/check', data).then(response => {
    // 适配标准格式：将 ApiResponse 转换为 AJ-Captcha 期望的格式
    if (response.success) {
      return {
        repCode: '0000',
        repMsg: 'success',
        repData: response.data
      }
    } else {
      return {
        repCode: '9999',
        repMsg: response.message || '验证失败',
        repData: null
      }
    }
  }).catch(error => {
    return {
      repCode: '9999',
      repMsg: error.response?.data?.message || '验证失败',
      repData: null
    }
  })
}

